import { isEqual } from 'lodash';
import React from 'react';
import DateField from '../../../components/forms/DateField';
import CustomSelect from '../../../components/forms/CustomSelect';
import useProviders from '../../../hooks/api-calls/useProviders';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useCompanies from '../../../hooks/api-calls/useCompanies';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';

interface HeadquartersFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
    noProvider?: boolean;
}

const HeadquartersFilters: React.FC<HeadquartersFiltersProps> = ({ filters, updateFilters, noProvider }) => {

    // HOOKS 

    const { getProvidersList } = useProviders();
    const { userCan } = usePrivilege();
    const { getCompaniesList } = useCompanies();


    // RENDER 

    return (
        <>
            <CustomTextDelayInput
                id="city"
                label="Ciudad"
                placeholder="Buscar por ciudad"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="province"
                label="Provincia"
                placeholder="Buscar por provincia"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="neighbourhood"
                label="Barrio"
                placeholder="Buscar por barrio"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="phone"
                label="Teléfono Fijo"
                placeholder="Buscar por teléfono"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="email"
                label="Email"
                placeholder="Buscar por email"
                filters={filters}
                updateFilters={updateFilters}
            />

            {!noProvider && (
                <CustomSelect
                    isSearchable
                    id={'provider'}
                    label="Proveedor"
                    placeholder="Elige proveedor"
                    value={{ value: filters.filter_filters?.provider, label: getProvidersList()?.find((g: any) => g.value === filters.filter_filters?.provider)?.label }}
                    options={getProvidersList()}
                    onChange={
                        (e: any) => { 
                            if (e?.value === 'null') {
                                updateFilters({ provider: null });
                                return;
                            }
                            updateFilters({ provider: e?.value });
                        }
                    }
                />
            )}

            <CustomSelect
                isSearchable
                id={'active'}
                label="Estado"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ active: null });
                        return;
                    }
                    updateFilters({ active: e.value });
                }}
                value={filters.filter_filters?.active !== null && filters.filter_filters?.active !== undefined
                    ? { label: filters.filter_filters?.active ? 'Activo' : 'Desactivado', value: filters.filter_filters?.active }
                    : { label: 'Todos', value: 'null' }}
            />

            <CustomSelect
                isSearchable
                id={'high_season'}
                label="Temporada alta"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Sí', value: true },
                    { label: 'No', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ high_season: null });
                        return;
                    }
                    updateFilters({ high_season: e.value });
                }}
                value={filters.filter_filters?.high_season !== null && filters.filter_filters?.high_season !== undefined
                    ? { label: filters.filter_filters?.high_season ? 'Sí' : 'No', value: filters.filter_filters?.high_season }
                    : { label: 'Todos', value: 'null' }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

             {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />  
            )}

        </>
    );
};

export default HeadquartersFilters;
